import * as Highcharts from 'highcharts';
import { createForecastPeriodConfigFormatted } from './teleconnections.utils';
import {
  ForecastPeriodConfig,
  TeleconnectionModels,
} from './teleconnection.types';

export const models: TeleconnectionModels[] = ['ECMWF', 'AIFS', 'GFS', 'GEM'];

export const forecastPeriodDateFormat = 'MM/DD';

export const forecastPeriodNotAvailable = '--/--';

export const forecastPeriodConfigNotAvailable: ForecastPeriodConfig = {
  startDate: null,
  endDate: null,
  formatted: createForecastPeriodConfigFormatted(null, null),
};

export const xAxisConfig: Highcharts.XAxisOptions = {
  type: 'datetime',
  labels: {
    formatter: function (this: Highcharts.AxisLabelsFormatterContextObject) {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const formatterContext = this;
      return Highcharts.dateFormat('%m/%d', <number>formatterContext.value);
    },
  },
};

export const defaultSeriesOptions = {
  type: 'spline',
  name: 'Observations',
  // animation: false,
  color: '#1E824C',
  linecap: 'square',
  lineWidth: 2,
  marker: {
    enabled: true,
    symbol: 'square',
  },
} as const;

export const defaultMultiSeriesOptions = {
  type: 'line',
  name: 'Ensemble Members',
  color: '#22313F',
  lineWidth: 1,
  marker: {
    enabled: false,
  },
  zIndex: -1,
  enableMouseTracking: false,
} as const;

export const chartConfig = {
  xAxis: xAxisConfig,
  title: {
    text: '',
  },
  credits: {
    enabled: true,
    text: 'AG2 Trader',
  },
  tooltip: {
    shared: true,
    crosshairs: true,
  },
  plotOptions: {
    series: {
      animation: false,
      selected: false,
      stickyTracking: true,
      states: {
        inactive: {
          opacity: 1,
        },
      },
    },
  },
  yAxis: {
    plotLines: [
      {
        tickInterval: 1,
        color: '#222222',
        width: 1,
        value: 0,
        zIndex: 1,
      },
    ],
    tickInterval: 1,
  },
};

export const modelComparisonConfigs = [
  {
    key: 'GFS_ENS',
    config: {
      color: '#0000fe',
      lineWidth: 3,
      name: 'GFS Ens',
      marker: {
        enabled: true,
        symbol: 'circle',
      },
    },
  },
  {
    key: 'GFS_OP',
    config: {
      color: '#0000fe',
      lineWidth: 1,
      name: 'GFS Op',
      marker: {
        enabled: true,
        symbol: 'diamond',
      },
    },
  },
  {
    key: 'ECMWF_ENS',
    config: {
      color: '#ff0000',
      lineWidth: 3,
      name: 'ECM Ens',
      marker: {
        enabled: true,
        symbol: 'circle',
      },
    },
  },
  {
    key: 'ECMWF_OP',
    config: {
      color: '#ff0000',
      lineWidth: 1,
      name: 'ECM Op',
      marker: {
        enabled: true,
        symbol: 'square',
      },
    },
  },
  {
    key: 'GEM_ENS',
    config: {
      color: '#1af824',
      lineWidth: 3,
      name: 'GEM Ens',
      marker: {
        enabled: true,
        symbol: 'circle',
      },
    },
  },
  {
    key: 'GEM_OP',
    config: {
      color: '#1af824',
      lineWidth: 1,
      name: 'GEM Op',
      marker: {
        enabled: true,
        symbol: 'triangle',
      },
    },
  },
  {
    key: 'AIFS_ENS',
    config: {
      color: '#8000ff',
      lineWidth: 3,
      name: 'AIFS Ens',
      marker: {
        enabled: true,
        symbol: 'circle',
      },
    },
  },
  {
    key: 'AIFS_OP',
    config: {
      color: '#8000ff',
      lineWidth: 1,
      name: 'AIFS Op',
      marker: {
        enabled: true,
        symbol: 'triangle-down',
      },
    },
  },
];

export const obsHistoryOptions = [
  {
    label: '30 Days',
    key: '30',
  },
  {
    label: '60 Days',
    key: '60',
  },
  {
    label: '90 Days',
    key: '90',
  },
];

export const modelTypeOptions = [
  {
    label: 'Operational',
    key: 'OP',
  },
  {
    label: 'Ensemble',
    key: 'ENS',
  },
];

export const trendsColorMap = ['#FF0000', '#FFB800', '#F74CFA', '#00F300'];
export const naTeneconnectingList = ['NADXSUM', 'NADXWTR'];
export const eurTeneconnectingList = ['EUDXWTR', 'EUDXSUM'];
export const TELECONNECTING_PERMISSIONS_KEY = 'Teleconnections';
export const TELECONNECTING_GLOBAL_PERMISSIONS_KEY = 'Global';
export const TELECONNECTING_CONTINENT_NA_PERMISSIONS_KEY = 'NA';
export const TELECONNECTING_CONTINENT_EUR_PERMISSIONS_KEY = 'EUR';
